import { AfterViewInit, Component, Input, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';

import { DragDropLayoutService } from '../drag-drop-layout/drag-drop-layout.service';
@Component({
  selector: 'app-installation-ordered-element',
  template: `<ng-content></ng-content>`,
})
export class InstallationOrderedElementComponent implements AfterViewInit, OnDestroy {
  private ngUnsubscribe$: Subject<void> = new Subject<void>();

  @Input() panel: string;
  @Input() orderKey: string;

  constructor(private dragAndDropLayoutService: DragDropLayoutService) {}

  ngAfterViewInit(): void {
    const canContinue = this.inputsValid();

    if (!canContinue) {
      return;
    }

    if (!this.dragAndDropLayoutService.renderedPanels[this.orderKey]) {
      this.dragAndDropLayoutService.renderedPanels[this.orderKey] = [];
    }
    if (!this.dragAndDropLayoutService.renderedPanels[this.orderKey].includes(this.panel)) {
      this.dragAndDropLayoutService.renderedPanels[this.orderKey].push(this.panel);
    }
  }

  private inputsValid(): boolean {
    if (!this.orderKey) {
      console.warn(
        `orderKey @Input() for ${this.panel} panel has not been provided, but is required`
      );

      return false;
    }

    return true;
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
